import type { ReactNode } from 'react'
import type { UseFormReturn } from 'react-hook-form'

import type { ParsedTemplateVariable } from '@/components/organisms/template-variable-editor/template-variable.interface'
import { FormField } from '@/components/ui/form'

import type { TemplateVariableFormValues } from './template-variable-form.interface'
import { TemplateVariableFormFieldContent } from './template-variable-form-field.molecule'

interface TemplateVariableFieldListProps {
  form: UseFormReturn<TemplateVariableFormValues>
  variableList: ParsedTemplateVariable[]
  isDisabled?: boolean
}

export const TemplateVariableFieldList: React.FC<TemplateVariableFieldListProps> = ({
  form,
  variableList,
  isDisabled = false,
}): ReactNode => (
  <>
    {variableList.map((variable) => (
      <FormField
        key={variable.name}
        control={form.control}
        name={variable.name}
        render={({ field }) => (
          <TemplateVariableFormFieldContent
            field={field}
            variable={variable}
            isDisabled={isDisabled}
          />
        )}
      />
    ))}
  </>
)

TemplateVariableFieldList.displayName = 'TemplateVariableFieldList'
